import type { DataGridColumn, DataGridFilterConfig, DataGridFilterRenderContext } from '@ibsys/kit';
import type { ReactNode } from 'react';
import type { ConversationListItem } from '@/entities/conversations';
import type { DialogColumnMeta } from '../columnMeta';

/** Колонка таблицы в том виде, в каком её читает описание отбора */
export type ColumnDescriptor = {
  id: string;
  /** Подпись колонки, как она стоит в шапке таблицы */
  header: string;
  filter?: DataGridFilterConfig;
  /** Рендерер кастомного фильтра колонки — им фильтр открывается и из описания */
  renderFilter?: (ctx: DataGridFilterRenderContext) => ReactNode;
  meta?: DialogColumnMeta;
};

/**
 * Собирает описываемые колонки в порядке их следования в таблице.
 * Колонки с нетекстовым заголовком описанию не поддаются и пропускаются.
 */
export const buildColumnDescriptors = (
  columns: DataGridColumn<ConversationListItem>[],
): Map<string, ColumnDescriptor> => {
  const descriptors = new Map<string, ColumnDescriptor>();

  const collect = (list: DataGridColumn<ConversationListItem>[]): void => {
    for (const column of list) {
      if ('columns' in column) {
        collect(column.columns);
        continue;
      }
      if (typeof column.header !== 'string') continue;
      descriptors.set(column.id, {
        id: column.id,
        header: column.header,
        filter: column.filter,
        renderFilter: column.renderFilter,
        meta: column.meta as DialogColumnMeta | undefined,
      });
    }
  };

  collect(columns);
  return descriptors;
};
